import { render, staticRenderFns } from "./ReservationStatus.vue?vue&type=template&id=34417005&scoped=true&"
import script from "./ReservationStatus.vue?vue&type=script&lang=js&"
export * from "./ReservationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34417005",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34417005')) {
      api.createRecord('34417005', component.options)
    } else {
      api.reload('34417005', component.options)
    }
    module.hot.accept("./ReservationStatus.vue?vue&type=template&id=34417005&scoped=true&", function () {
      api.rerender('34417005', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/common/ReservationStatus.vue"
export default component.exports